<template>
	<div
    class="width-200 d-inline-block mr-1 align-top">
    <div class="w-100 cursor-pointer" @click="toggleDetail">
      <img
        :src="data.image_url"
        class="w-100 rounded"
        width="145"
        height="170"
        style="object-fit: cover;"
      />
      <p class="mb-0 body-15 text-truncate text-black mt-1">{{data.name}}</p>
      <!-- <p
        class="mb-0 body-2-2 text-truncate"
        :class="{'d-none':data.description == '' || data.description == null}"
      >{{data.description}}</p>
      <div class="d-none" style="height: 21px;" :class="{'d-block':data.description == '' || data.description == null}"></div> -->
      <p
        class="mb-0 body-2-2 text-truncate font-semibold text-light-menu text-line-through"
        v-if="is_decrease_promo"
      >{{ formatCurrency(promotion_price) }}</p>
      <!-- <div
        class="d-block"
        v-else
        style="height: 21px;"
      ></div> -->
      <p
        class="mb-0 body-15 text-truncate font-semibold text-color-orange"
      >{{ formatCurrency(final_price) }}</p>
    </div>

    <menuDetail v-if="show_detail" :data="data" @done="toggleDetail" />
  </div>
</template>
<script>
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
  import menuDetail from '@/components/restaurant-v2/menuDetail'

	export default{
    components:{
      menuDetail
    },
		props: ['data'],
		data(){
			return{
				show_detail: false
			}
		},
		computed:{
			is_variant(){
        return this.data.variant_list.length == 0 ? false : true
      },
      base_price(){
        return this.is_variant ? this.data.variant_list[0].price : this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? (this.base_price.price_sell_base) : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
		},
		methods:{
			formatCurrency(value){
        return formatCurrency(value);
      },
      toggleDetail(){
        this.show_detail = !this.show_detail
      },
		}
	}
</script>
<style scoped>

.object-fit {
  object-fit: cover;
}

.width-200 {
  width: 170px !important;
  margin: 0 8px;
}

.text-light-menu {
  color: #9ba1aa;
}
</style>


// WEBPACK FOOTER //
// src/components/restaurant-v2/menuItemCustom.vue